export const CATALOG = 'catalog';
export const CATALOG_PRODUCT_FETCH = 'CATALOG_PRODUCT_FETCH';
export const CATALOG_CATEGORY_FETCH = 'CATALOG_CATEGORY_FETCH';
